import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '@/types/Auth.types';
import AppStorage from '@/utils/helpers';

type AuthState = {
  user: User | null;
  isAuthenticated: boolean;
  loading: boolean;
};

const loadUserFromAppStorage = () => {
  if (typeof window !== 'undefined') {
    const token = AppStorage.get('atk');
    if (token) {
      return true;
    }
  }
};
const loadUserDataFromAppStorage = () => {
  if (typeof window !== 'undefined') {
    const user = AppStorage.get('user');
    return user ? JSON.parse(user) : null;
  }
};

const initialState: AuthState = {
  user: loadUserDataFromAppStorage(),
  isAuthenticated: loadUserFromAppStorage() || false,
  loading: true,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    signinUser: (state, { payload }: PayloadAction<User>) => {
      state.user = payload;
      state.isAuthenticated = true;
      state.loading = false;
      saveUserToAppStorage(payload);
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.loading = false;
    },
    finishLoading: (state) => {
      state.loading = false;
    },
  },
});

const saveUserToAppStorage = (user: User) => {
  AppStorage.save('user', JSON.stringify(user));
};
const { actions, reducer: AuthReducer } = authSlice;

export const { signinUser, finishLoading, logout } = actions;
export default AuthReducer;
